import React from "react";
import AuctionMoreCard from "./AuctionMoreCard";
const AuctionMore = () => {
    const cardItems = [1, 2, 3, 4];
    return (
        <div className="_nft_artist_wrapper _nft_auct_artist_wrapper">
            <div className="_nft_artist_wrap">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                            <h2 className="_nft_artist_title">
                                More From Artist
                            </h2>
                        </div>
                    </div>
                    <div className="_nft_artist_content_wrap">
                        <div className="row">
                            {
                                cardItems.map((card, id) => {
                                    return <AuctionMoreCard key={id} />
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default AuctionMore;